import * as z from "zod";
import { MarketingAgentAnalyticsInputSchema } from "./common";

const ChannelDistributionItemSchema = z.object({
  channel: z.string(),
  count: z.number(),
});

export const getMarketingAgentChannelDistribution = {
  name: "getMarketingAgentChannelDistribution" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.array(ChannelDistributionItemSchema),
};
